import { Tabs as MantineTabs } from '@mantine/core';

export const Tabs = MantineTabs.extend({
	defaultProps: {
		variant: 'pills',
	},
});
